import { DirectoryLinkedQuestionDetails, DirQuestionPiping } from './directory-linking';
import { ContactRules } from './questions';
import { ResponseInfo } from './response-info';

export class ParticipationResponseData {
  ResponseDatas: ResponseData[];
  ResponseCommanData: ResponseCommanData;
  directoryLinkedQuestionDetails: DirectoryLinkedQuestionDetails;
  dirQuestionPipings: DirQuestionPiping[];
  contactRules: ContactRules[];
  responseInfo: ResponseInfo;
}

export class ResponseData {
  page_no: number;
  QuestionID: number;
  AnswerID: number;
  AnswerText: string;
  IsOther: boolean;
  Qno: number;
  QType: string;
  BranchQID: number;
}

export class ResponseCommanData {
  SurveyID: number;
  ResponseUID: number;
  SavedPageList: string;
  isReopenSurvey: boolean;
  isEmbedMobile: boolean;
  isEmbedPopMobile: boolean;
  isEmbedPopWeb: boolean;
  QDLSkippedQID: string;
  Screen_Resolution: string;
  dtResponseStartDate: string;
  dtResponseEndDate: string;
  ResponseLangID: number;
  ResponseStatus: string;
  dtDispResponseStartDate: string;
  dtDispResponseEndDate: string;
  OfflineUID: number;
  isConstraintAlert: boolean;
}
